<template>
  <div id="index">
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt="" /></i>
        <h4 class="header_title">麻醉眼界</h4>
      </header>
      <!-- 内容 -->
      <div class="recommended">
        <div class="recommended_head">
          <div class="recommended_title flex_start">
            <span class="tag flex_center">活动</span>
            {{activity.title}}
          </div>
          <div class="flex_between author">
            <div>活动时间：{{activity.start_time}}——{{activity.end_time}}</div>
          </div>
        </div>
        <div class="recommended_center li_r_img" v-html="activity.content">
        </div>
        <!-- <p><embed src="http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/29cf1544cfc75cac1dae67e51e103261.mp4" width="420" height="280" wmode="transparent" play="true" loop="false" menu="false" allowscriptaccess="never" allowfullscreen="false"/></p> -->
        <!-- <div class="video_view">
                    <video :src="detail.cover_video"  preload controls poster></video>
                </div> -->
      </div>
      <!-- /* 底部按钮 */ -->
      <div class="flex_around btn_dv">
        <div class="cy_btn flex_center" @click="activityFrom">上传作品</div>
        <div class="zp_btn flex_center" @click="activityList">作品列表</div>
      </div>

    </div>
    <!-- 提示注册弹窗 -->
    <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
  </div>
</template>

<script>
  import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
  export default {
    name: "index",
    data() {
      return {
        id: 0, //推文id
        activity: {}, //内容

        is_app: this.$store.state.is_app,
      };
    },
    computed: {


    },
    components: {
      LoginPrompt
    },
    watch: {},
    methods: {
      promptFun() {//提示弹窗回调
        this.$store.commit('queryUrl', '/m_activity?id=' + this.id)
        this.$router.replace({ path: '/m_password', query: {} });
      },
      // 参加活动
      activityFrom() {
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.prompt.popupFun();
          return false;
        }
        this.$router.push({ path: '/m_activityform', query: { id: this.id } });
      },
      // 作品列表
      activityList() {
        this.$router.push({ path: '/m_activitylist', query: { id: this.id } });
      },

      goBackward() {
        //返回上一页
        if (window.history.length > 2) {
          this.$router.go(-1);
        } else {
          this.$router.replace("/m_home");
        }
      },
      getDetails() {
        //获取详情
        let that = this;
        this.$post("index-view", { id: this.id }).then((res) => {
          that.activity = res.data;
          that.getShare(that.activity.title, that.activity.cover ? that.details.cover : '');
        });
      },
    },
    mounted() {
      this.id = this.$route.query.id;
      this.getDetails();

      if (this._isMobile()) {

      } else {
        // alert("pc端");
        this.$router.push({ path: '/pc_activity', query: { id: this.id } });
      }
    },
  };
</script>
<style>
  .recommended .recommended_center img {
    max-width: 90%;
  }

  .recommended .recommended_center video {
    max-width: 100%;
    height: auto;
  }
</style>
<style scoped>
  html,
  body {
    max-width: 100vw;
  }
#index{
  padding-bottom: 6rem;
}
  .visible-xs {
    width: 100vw;
    overflow: hidden;
    padding-top: 0rem;
  }

  /* 内容 */
  .recommended_head {
    padding: 1rem 1.5rem;
    border-bottom: 0.05rem solid #dfdfdf;
  }

  .recommended_head .recommended_title {
    font-size: 1.6rem;
    color: #333;
  }

  .recommended_head .recommended_title .tag {
    height: 1.7rem;
    padding: 0 0.7rem;
    border-radius: 0.2rem;
    border: 0.1rem solid red;
    font-size: 1rem;
    color: red;
    margin-right: 1rem;
    white-space: nowrap;
    transform: translateY(.2rem);
  }

  .recommended_head .author {
    margin-top: 1.4rem;
    align-items: flex-start;
  }

  .recommended_head .author .original {
    color: #666;
    font-size: 1.4rem;
  }

  .recommended_center {
    padding: 1.2rem 1.6rem;
    font-size: 1.3rem;
    color: #333;
  }

  .author .time {
    white-space: nowrap;
  }

  .video_view {
    width: calc(100vw - 3rem);
    margin: 1rem auto;
  }

  .video_view>video {
    width: 100%;
  }

  /* 底部按钮 */
  .button_buttom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4.8rem;
    border-top: 0.05rem solid #dfdfdf;
    background: #fff;
  }

  .button_buttom i {
    width: 2rem;
    margin: 0 auto;
  }

  .button_buttom span {
    font-size: 1.2rem;
    color: #666;
  }

  .button_buttom .button_left {
    width: 20%;
  }

  .button_buttom .button_left>i {
    margin-right: 0.45rem;
  }

  .button_buttom .button_li {
    flex-direction: column;
    text-align: center;
    width: 14vw;
  }

  .btn_dv {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    height: 6rem;
    z-index: 99;
    background: #fff;
    /* margin-top: 7.7rem; */
    box-shadow: -.2rem 0 1rem rgba(0,0,0,.1);
  }

  .cy_btn {
    width: 13.7rem;
    height: 3rem;
    text-align: center;
    border-radius: 0.5rem;
    background: #e0595f;
    border: solid 0.15rem #e0595f;
    color: #fff;
    font-size: 1.6rem;
  }

  .zp_btn {
    width: 13.7rem;
    height: 3rem;
    text-align: center;
    border-radius: 0.5rem;
    border: solid 0.15rem #a0a0a0;
    font-size: 1.6rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/minActivity/m_activity.vue